<template>
  <div>
    <h1 style="font-size: xx-large; line-height: 35px; font-weight: bold;" :style="{ color: $ajustes.colorTexto2 }">
      CONTACTANOS</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">
      Pregunta sobre nuestros cursos</h1>
    <v-row class="pt-2 ">
      <v-col class="ma-0 pa-2" lg="4" md="4" sm="6" cols="12">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">Información Institucional</h1>
          <span class="mt-2" style="font-size: small;"><strong>Dirección: </strong> {{ propInstituto.direccion }}</span>
          <span class="mt-2" style="font-size: small;"><strong>Teléfono: </strong> {{ propInstituto.telefono }}</span>
          <span class="mt-2" style="font-size: small;"><strong>Email: </strong> {{ propInstituto.correo }}</span>
          <span class="mt-2" style="font-size: small;"><strong>Horario de atención: </strong><br> {{
            propInstituto.horario_dias }} <br> {{ propInstituto.horario_horas }} </span>
          <span class="mt-2" style="font-size: small;"><strong>Redes Sociales</strong>
            <br>
            <strong>
              <a :href="propLinks.linkFacebook" target="_blank" rel="noopener" style="color: blue;">Facebook</a>
              |
              <a :href="propLinks.linkInstagram" target="_blank" rel="noopener" style="color: blue;">Instragram</a>
              |
              <a :href="propLinks.linkYoutube" target="_blank" rel="noopener" style="color: blue;">Youtube</a>
            </strong>
          </span>
        </v-container>
      </v-col>
      <v-col class="ma-0 pa-2" lg="4" md="4" sm="6" cols="12">
        <v-container>
          <h1 class="mb-3" style="text-align: justify; line-height: 20px; font-size: 15pt;">Envíanos un mensaje</h1>
          <formulario />
        </v-container>
      </v-col>
      <v-col class="ma-0 pa-2" lg="4" md="4" sm="6" cols="12">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">Enlaces Útiles</h1>
          <span class="mt-2" style="font-size: small;">
            <a @click="goto('Nosotros')" style="color: blue;text-decoration: underline">Acerca de la institución</a>
            <br>
            <a @click="goto('Cursos')" style="color: blue;text-decoration: underline">Oferta Académica</a>
            <br>
            <a href="https://aulavirtual.inseg.com.ec/" style="color: blue;text-decoration: underline">Acceso a
              Moodle</a>
            <br>
            <a @click="goto('Noticias')" style="color: blue;text-decoration: underline">Noticias y Eventos</a>
          </span>
          <br>
        </v-container>
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">Accesibilidad</h1>
          <span class="mt-2 pr-5" style="font-size: small;">{{ propInstituto.accesibilidad }}</span>
          <br>

        </v-container>

      </v-col>

    </v-row>
    <br>
  </div>
</template>
<script>
import formulario from "@/components/template/formulario";

export default {
  components: {
    formulario
  },
  props: {
    propInstituto: { type: Object },
    propLinks: { type: Object }
  },
  data() {
    return {
    };
  },
  mounted() {
  },

  created() { },
  computed: {},
  methods: {

    goto(aux) {
      this.$router.push({ name: aux })
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
